import axios from "axios";

const getData = async (endpoint, headers, cancelToken) => {
    try {
        return await axios.get(endpoint,{
            headers: headers,
            cancelToken
        });
    } catch(e) {
        console.error(e);
        throw new Error(e);
    }
};

export {
    getData
}